/* eslint-disable
    consistent-return,
    default-case,
    no-cond-assign
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS104: Avoid inline assignments
 * DS201: Simplify complex destructure assignments
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import $ from 'jquery';

import React from 'react';
import isEqual from 'react-fast-compare';

import reactUpdate from 'immutability-helper';
import ReactDOMServer from 'react-dom/server';
import _ from 'underscore';

import * as benchlingUtil from 'BenchlingUtil';
import {COLORS} from 'ui-library/ColorPickerConstants';
import FormattersConstants from 'notebook/mediocre/formatted-text/FormattersConstants';
import parseDOMColor from 'notebook/mediocre/clipboard/parseDOMColor';
import {addSearchResultsToFormats} from 'notebook/mediocre/formatted-text/FormattedTextSearchResults';
import {getSelectedSearchResultDataAttrs} from 'notebook/mediocre/search/DOM';
import {forwardSearchResultProps} from 'notebook/mediocre/search/SearchResultProps';
import BenchlingConfig from 'BenchlingConfig';

const {
  BOLD,
  CYCLE_HEADER,
  LINK,
  INTERNAL_LINK,
  ITALIC,
  MONOSPACE,
  UNDERLINE,
  STRIKETHROUGH,
  SUBSCRIPT,
  SUPERSCRIPT,
  SYMBOL,
  FOREGROUND_COLOR,
  BACKGROUND_COLOR,
  POINT_FORMATS,
  CHIP_WIDTH,
  DAY,
  SEARCH_RESULT,
} = FormattersConstants;

import {assert, assertAndContinue} from 'Asserts';
import isValidLink from 'util/isValidLink';
import * as keyboard from 'util/Keyboard';
import * as logging from 'util/Logging';

const FORMAT_TO_TAG = _.object([
  [BOLD, 'B'],
  [ITALIC, 'I'],
  [UNDERLINE, 'U'],
  [STRIKETHROUGH, 'DEL'],
  [SUBSCRIPT, 'SUB'],
  [SUPERSCRIPT, 'SUP'],
  [LINK, 'A'],
  [FOREGROUND_COLOR, 'SPAN'],
  [BACKGROUND_COLOR, 'SPAN'],
  [SEARCH_RESULT, 'SPAN'],
  [MONOSPACE, 'CODE'],
]);

const TAG_TO_FORMAT = _.chain(FORMAT_TO_TAG)
  .omit(FOREGROUND_COLOR, BACKGROUND_COLOR, SEARCH_RESULT)
  .invert()
  .extend({
    STRONG: BOLD,
    EM: ITALIC,
  })
  .value();

const EVENT = {START: 0, END: 1, POINT: 2};
let HAS_WARNED_FOR_EMPTY_RANGE = false;

const SHORTCUT_TO_FORMAT = {
  'Ctrl + B': BOLD,
  'Ctrl + I': ITALIC,
  'Ctrl + U': UNDERLINE,
  'Ctrl + Shift + X': STRIKETHROUGH,
  'Ctrl + K': LINK,
  'Ctrl + Shift + K': MONOSPACE,
  'Ctrl + ;': SYMBOL,
  'Ctrl + .': SUPERSCRIPT,
  'Ctrl + Shift + .': SUBSCRIPT,
  // On Windows, Ctrl + Shift + . comes across as Ctrl + Shift + >
  'Ctrl + Shift + >': SUBSCRIPT,
  'Ctrl + \\': DAY,
};

const FORMAT_TO_SHORTCUT = _.invert(SHORTCUT_TO_FORMAT);

// Sanitizes a dictionary of format range arrays. Merges ranges that overlap (except links),
// and removes empty ranges.
function processRanges(formatRanges) {
  let flattened;
  let ranges;
  const newFormats = {};
  for (const format of [BOLD, ITALIC, UNDERLINE, STRIKETHROUGH, SUBSCRIPT, SUPERSCRIPT, MONOSPACE]) {
    ranges = formatRanges[format];
    assertAndContinue(
      // eslint-disable-next-line no-restricted-syntax
      _.every(ranges, (r) => r.start <= r.end),
      `Invalid range values: ${JSON.stringify(ranges)}`
    );
    assertAndContinue(
      // eslint-disable-next-line no-restricted-syntax
      _.every(ranges, (r) => r.data == null || isEqual(r.data, {})),
      'None of these formats have data attributes, since we throw them away.'
    );
    flattened = _(ranges)
      .chain()
      // Take out any empty ranges, (and bad ranges if assertAndContinue fails but we have continued).
      .filter((range) => range.start < range.end)
      .map((range) => [
        {type: EVENT.START, index: range.start},
        {type: EVENT.END, index: range.end},
      ])
      .flatten()
      .sortBy('type')
      .sortBy('index')
      .value();

    const combined = [];
    let numStarts = 0;
    let currentStart = null;

    // Combines any contiguous ranges or nested into one range. Uses the fact that 'starts' will appear
    // before 'ends' for the same index (from sortBy above).
    for (const {index, type} of Array.from(flattened)) {
      if (type === EVENT.START) {
        if (numStarts === 0) {
          currentStart = index;
        }
        numStarts += 1;
      } else {
        numStarts -= 1;
        if (numStarts === 0) {
          combined.push({start: currentStart, end: index, data: {}});
        }
      }
    }
    newFormats[format] = combined;
  }

  for (const format of [FOREGROUND_COLOR, BACKGROUND_COLOR]) {
    ranges = formatRanges[format];
    assertAndContinue(
      // eslint-disable-next-line no-restricted-syntax
      _.every(ranges, (r) => r.start <= r.end),
      `Invalid range values: ${JSON.stringify(ranges)}`
    );
    flattened = _(ranges)
      .chain()
      // Take out any empty or bad ranges
      .filter((range) => range.start < range.end)
      .uniq((range) => `${range.start}_${range.end}_${range.data != null ? range.data.color : undefined}`)
      .sortBy('start')
      .value();
    newFormats[format] = flattened;
  }

  // Don't do any processing on links (don't combine contiguous ones, they should never overlap anyway).
  for (const format of [LINK, INTERNAL_LINK]) {
    newFormats[format] = formatRanges[format];
  }
  return newFormats;
}

function hasPointFormatting(formats) {
  return POINT_FORMATS.some((format) => (formats != null ? formats[format].length : undefined) > 0);
}

function addRange(formatRanges, format, range) {
  const newFormats = reactUpdate(formatRanges, benchlingUtil.kv(format, {$push: [range]}));
  return processRanges(newFormats);
}

function removeRange(formatRanges, format, rangeToRemove) {
  const ranges = formatRanges[format];
  const newRanges = [];
  for (const range of Array.from(ranges)) {
    const overlapStart = Math.max(range.start, rangeToRemove.start);
    const overlapEnd = Math.min(range.end, rangeToRemove.end);
    if (overlapStart >= overlapEnd) {
      newRanges.push(range);
    } else {
      // Adds the outer parts of the range that are not in overlap. These may be empty,
      // and are cleaned up in processRanges.
      newRanges.push({start: range.start, end: overlapStart, data: range.data});
      newRanges.push({start: overlapEnd, end: range.end, data: range.data});
    }
  }
  const newFormats = reactUpdate(formatRanges, {$merge: _.object([format], [newRanges])});
  return processRanges(newFormats);
}

// Given an object of format ranges, returns an array of event points (starts or ends) that
// correspond to a valid DOM representation of the formats. For instance, <b><i></i></b> is valid
// but <b></i></b></i> is not.
// Links are handled specially, since they can't be started and stopped arbitrarily (i.e <a>hi</a><a>hi</a>
//   is different from <a>hihi</a>).
// We go through a sorted array of events, and keep a stack of 'open' formats. Whenever we reach a 'close'
// format, we close events on the stack until we reach the current format. Then, we add the previous
// formats back onto the stack.
// This results in {bold: [0,5], italic: [2:7]} looking like <b>AA<i>BBB</i></b><i>CC</i>.
// Some formats are located at a point rather than a range. When a point format is reached all currently
// open formats are closed before adding the point onto the linearized list. The closed formats are reopened
// by adding them back onto the stack.
function linearizeFormats(formats) {
  // Given the current format point, close everything on the stack until we find the given format. Add that
  // format onto the returned events array, then put everything back on the stack. Usually, this is used for
  // close events, but this is also used for open LINK events (since we need to close everything before
  // starting a link).

  function addToOutput(linearized, point) {
    if (linearized.length === 0) {
      linearized.push(point);
      return;
    }

    const last = linearized[linearized.length - 1];
    const {type, format, index} = point;
    if (type === EVENT.END && last.type === EVENT.START && format === last.format && index === last.index) {
      linearized.pop();
    } else {
      linearized.push(point);
    }
  }

  function clearStackFor(linearized, stack, newFormatPoint) {
    let formatPoint;
    const splits = [];
    while (stack.length > 0 && (formatPoint = stack.pop()).format !== newFormatPoint.format) {
      addToOutput(linearized, {format: formatPoint.format, index: newFormatPoint.index, type: EVENT.END});
      splits.push(formatPoint);
    }

    addToOutput(linearized, newFormatPoint);
    for (let i = splits.length - 1; i >= 0; i--) {
      const point = splits[i];
      const newStart = {
        format: point.format,
        data: point.data,
        index: newFormatPoint.index,
        type: EVENT.START,
      };
      stack.push(newStart);
      addToOutput(linearized, newStart);
    }
  }

  let combinedFormats = [];
  for (const format of Object.keys(formats)) {
    const ranges = formats[format];
    for (const range of Array.from(ranges)) {
      if (Array.from(POINT_FORMATS).includes(format)) {
        combinedFormats.push({format, data: range.data, index: range.position, type: EVENT.POINT});
      } else {
        // If a format has 0 length (which it never should!) we should skip over it and log it.
        if (range.start === range.end) {
          // We should only error for this once.
          if (!HAS_WARNED_FOR_EMPTY_RANGE) {
            // Updated message to include the task number (T5755) at the end so we can distinguish
            // between errors that occurred before the getFormattedTextFromRenderedElement fix and after.
            logging.warn(`Attempted to add a range with 0 length for format ${format} (T5755)`);
            HAS_WARNED_FOR_EMPTY_RANGE = true;
          }
          continue;
        }
        combinedFormats.push({format, data: range.data, index: range.start, type: EVENT.START});
        combinedFormats.push({format, index: range.end, type: EVENT.END});
      }
    }
  }

  function sortOrder({type}) {
    switch (type) {
      case EVENT.END:
        return 0; // ranges must terminate before another or a point
      case EVENT.POINT:
        return 1; // points take precedence over start
      case EVENT.START:
        return 2;
    }
  }

  combinedFormats = _(combinedFormats).chain().sortBy(sortOrder).sortBy('index').value();
  const stack = [];
  const linearized = [];
  for (const formatPoint of Array.from(combinedFormats)) {
    if (formatPoint.type === EVENT.START) {
      // We never split
      // - LINK: a hyperlink's hover state / interaction would also be split.
      // - MONOSPACE: it has padding + backgroundColor which will clash with a wrapping BACKGORUND_COLOR
      if (formatPoint.format === LINK || formatPoint.format === MONOSPACE) {
        clearStackFor(linearized, stack, formatPoint);
      } else {
        addToOutput(linearized, formatPoint);
        stack.push(formatPoint);
      }
    } else {
      clearStackFor(linearized, stack, formatPoint);
    }
  }

  return linearized;
}

function renderAttrs(attributes) {
  return Object.entries(attributes)
    .map(([key, value]) => `${key}='${_.escape(value)}'`)
    .join(' ');
}

function renderFormatStart(format, data) {
  if (format === LINK) {
    let url = _.escape(data.url);
    if (!isValidLink(data.url)) {
      url = `http://${url}`;
    }
    return `<A href='${url}' rel='nofollow noopener noreferrer' target='_blank'>`;
  } else if (format === SEARCH_RESULT) {
    // TODO(BNCH-40448): Selecting search result text, NoteToolbar will surface as a background color.
    return `<${FORMAT_TO_TAG[format]} ${renderAttrs(
      getSelectedSearchResultDataAttrs(data.selected ? data.uuid : undefined)
    )} class='mediocre-searchResult ${data.selected ? 'is-selected' : ''}' >`;
  } else if (format === FOREGROUND_COLOR || format === BACKGROUND_COLOR) {
    // It's non-trivial to escape user input for CSS, so we only include it we detect a valid CSS color.
    // `color` will be null or a hex value (e.g. #FF0000)
    const color = parseDOMColor(data.color);
    const attr = format === FOREGROUND_COLOR ? 'color' : 'background-color';
    if (color) {
      return `<${FORMAT_TO_TAG[format]} style='${_.escape(attr)}:${_.escape(color)}'>`;
    }
  }
  return `<${FORMAT_TO_TAG[format]}>`;
}

function renderFormatEnd(format) {
  return `</${FORMAT_TO_TAG[format]}>`;
}

function renderList(data, indentation) {
  return `${'<UL>'.repeat(indentation)}<LI style='margin:0'>${data}</LI>${'</UL>'.repeat(indentation)}`;
}

function renderFormatPoint(format, data, param /* extends MediocreSearchResultProps */) {
  assert(format === INTERNAL_LINK);
  const InternalLink = require('notebook/mediocre/mentions/InternalLink').default; // Avoid circular deps
  return ReactDOMServer.renderToStaticMarkup(
    <InternalLink internalLink={data} {...forwardSearchResultProps(param)} />
  );
}

function getFormatData(el, options) {
  if (options == null) {
    options = {};
  }
  const wyciwyp = require('notebook/mediocre/clipboard/wyciwyp').default;

  const formats = [];

  // Abort for non-element nodes (e.g. text nodes). There are no styles / attributes to parse otherwise.
  if (el.nodeType !== Node.ELEMENT_NODE) {
    return formats;
  }

  let nodeName = typeof options.getNodeName === 'function' ? options.getNodeName(el.nodeName) : undefined;
  nodeName = nodeName != null ? nodeName : el.nodeName;

  // Handle internalLinks first as we don't actually want to process their internal styles.
  if (nodeName === 'SPAN' && $(el).hasClass('internalLink')) {
    const internalLink = JSON.parse(el.getAttribute('data-internal-link'));
    formats.push({format: INTERNAL_LINK, data: internalLink});
    return formats;
  }

  // Read format from nodeName
  const format = TAG_TO_FORMAT[nodeName]; // okay if undefined
  if (format === LINK) {
    const url = el.getAttribute('href');
    if (isValidLink(url)) {
      formats.push({format: LINK, data: {url}});
    }
  } else if (format != null && ![FOREGROUND_COLOR, BACKGROUND_COLOR].includes(format)) {
    formats.push({format, data: {}});
  }

  // If style is undefined, return.
  // Note that el.style is only undefined for non-HTML attributes (important for imports).
  if (el.style == null) {
    return formats;
  }

  // Read format from styles
  if (el.style.fontWeight === 'bold') {
    formats.push({format: BOLD, data: {}});
  }
  if (el.style.textDecoration === 'underline') {
    formats.push({format: UNDERLINE, data: {}});
  }
  if (el.style.fontStyle === 'italic') {
    formats.push({format: ITALIC, data: {}});
  }
  if (el.style.textDecoration === 'line-through' || ['DEL', 'STRIKE'].includes(nodeName)) {
    formats.push({format: STRIKETHROUGH, data: {}});
  }
  if (el.style.fontFamily && el.style.fontFamily.match(/\b(mono|monospace|courier)\b/i)) {
    formats.push({format: MONOSPACE, data: {}});
  }
  const foregroundColor = wyciwyp.parseDOMColor(el.style.color || el.getAttribute('color'));
  if (foregroundColor != null) {
    formats.push({
      format: FOREGROUND_COLOR,
      data: {color: foregroundColor},
    });
  }
  const backgroundColor = wyciwyp.parseDOMColor(el.style.backgroundColor);
  if (backgroundColor != null) {
    formats.push({
      format: BACKGROUND_COLOR,
      data: {color: backgroundColor},
    });
  }

  // [BNCH-6031] OneNote uses style='vertical-align:super' for superscripts
  if (el.style.verticalAlign === 'super') {
    formats.push({
      format: SUPERSCRIPT,
      data: {},
    });
  }

  return formats;
}

function getOverlappingLinks(linkRanges, start, end) {
  // eslint-disable-next-line no-restricted-syntax
  const overlaps = _.filter(linkRanges, (range) => {
    if (start === end) {
      return range.start <= start && start < range.end;
    }
    return Math.max(start, range.start) < Math.min(end, range.end);
  });
  return overlaps;
}

const formatters = {
  _testing: {
    processRanges,
    addRange,
    linearizeFormats,
    renderFormatStart,
    renderFormatEnd,
    getFormatData,
    getOverlappingLinks,
    renderAttrs,
  },

  defaultFormats() {
    return {
      bold: [],
      italic: [],
      underline: [],
      strikethrough: [],
      subscript: [],
      superscript: [],
      link: [],
      internalLink: [],
      foregroundColor: [],
      backgroundColor: [],
      monospace: [],
    };
  },

  formatTypeFromKeydown(e, param) {
    if (param == null) {
      param = {};
    }
    let {allowLink} = param;
    if (allowLink == null) {
      allowLink = true;
    }
    // CYCLE_HEADER is a special shortcut in that we use real Ctrl and not Cmd on Macs
    if (e.key === '`' && e.ctrlKey && !e.shiftKey && !e.metaKey && !e.altKey) {
      return CYCLE_HEADER;
    }
    const format = SHORTCUT_TO_FORMAT[keyboard.getNormalizedShortcut(e)] || null;
    if (format === LINK && !allowLink) {
      return null;
    }
    if (format === 'day' && BenchlingConfig.ELN_ENABLE_ENTRY_SECTIONS) {
      return FormattersConstants.SECTION;
    }
    return format;
  },

  /*
  Takes an array of formatted texts ({text, formats}) and applies the given format, toggling on if any
  text is not fully-formatted or toggling off if all texts are fully formatted.
  */
  formatTexts(fmtTexts, {format, data}) {
    assert(format !== LINK);
    // Toggle format on if there is any item that is not entirely formatted.
    const removeFmt = fmtTexts.every(({text, formats}) => {
      if (text.length === 0) {
        return true;
      }
      const ranges = formats[format];
      return ranges.length === 1 && ranges[0].start === 0 && ranges[0].end === text.length;
    });

    // Apply the formatting
    return fmtTexts.map(({text, formats}) => {
      const partition = {before: '', selected: text, after: ''};
      ({text, formats} = formatters.formatText(formats, {
        format,
        data,
        partition,
        disableToggle: !removeFmt,
      }));
      return {text, formats};
    });
  },

  /*
  Takes a format (bold, italics, underline, subscript, superscript) and a selection partition,
  and returns the post-formatted text and selection start/end. Links are handled separately.
  */
  formatText(currentFormatRanges, {format, data, partition, disableToggle}) {
    let newFormats;
    assert(format !== LINK);
    if ([FOREGROUND_COLOR, BACKGROUND_COLOR].includes(format)) {
      disableToggle = true;
    }
    if (disableToggle == null) {
      disableToggle = false;
    } // disallow toggling if the range is fully formatted.
    const {before, selected, after} = partition;
    const start = before.length;
    const end = start + selected.length;
    const oldRanges = currentFormatRanges[format];

    // If the given range is already fully bolded, then unbold it. Otherwise bold it.
    if (!disableToggle && _.any(oldRanges, (range) => range.start <= start && range.end >= end)) {
      newFormats = removeRange(currentFormatRanges, format, {start, end});
    } else if ([FOREGROUND_COLOR, BACKGROUND_COLOR].includes(format) && data.color === COLORS.NO_STYLE) {
      newFormats = removeRange(currentFormatRanges, format, {start, end});
    } else {
      if ([SUPERSCRIPT, SUBSCRIPT].includes(format)) {
        // Right now our model doesn't support nested sub/superscripts, so when we use
        // one of them to format text, we need to clear the other for the full range.
        const otherFormat = format === SUBSCRIPT ? SUPERSCRIPT : SUBSCRIPT;
        newFormats = removeRange(currentFormatRanges, otherFormat, {start, end});
      } else if ([FOREGROUND_COLOR, BACKGROUND_COLOR].includes(format)) {
        newFormats = removeRange(currentFormatRanges, format, {start, end});
      } else {
        newFormats = currentFormatRanges;
      }
      newFormats = addRange(newFormats, format, {start, end, data});
    }
    return {formats: newFormats, start, end, text: before + selected + after};
  },

  /*
  Replaces the selected text with insertText (handling formats shifting)
  and returns the new formats, text, and the start and end of the newly inserted text.
  */
  replaceText(formats, partition, replacementText) {
    const {before, after, selected} = partition;

    // Compute final text + selection
    const start = before.length;
    const end = start + replacementText.length;
    const text = before + replacementText + after;

    // If the text hasn't changed, the format is valid as is.
    if (replacementText === selected) {
      return {formats, text, start, end};
    }

    // Otherwise... first isolate the formats of the text being replaced into middleFormats
    const {before: beforeFormats, after: middleAfterFormats} = this.splitFormats(formats, before.length);
    const splitMiddleAfterFormats = this.splitFormats(middleAfterFormats, selected.length);
    let {before: middleFormats} = splitMiddleAfterFormats;
    const {after: afterFormats} = splitMiddleAfterFormats;

    // If the replace region is non-empty, use the formatting of the first character, otherwise no formatting.
    if (selected.length === 0 && before.length === 0) {
      middleFormats = this.defaultFormats();
    } else {
      if (selected.length > 0) {
        ({before: middleFormats} = this.splitFormats(middleFormats, 1));
      } else {
        // Set afterPoint to true since we do not want to keep the point formatting of the previous character.
        ({after: middleFormats} = this.splitFormats(beforeFormats, before.length - 1, true));
      }
      middleFormats = _.mapObject(middleFormats, (ranges) => {
        if (ranges.length === 0) {
          return ranges;
        } else {
          return reactUpdate(ranges, {0: {end: {$set: replacementText.length}}});
        }
      });
    }

    // Re-join the formats together with the new middleFormats for replacementText.
    const newFormats = this.joinFormats(
      this.joinFormats(beforeFormats, middleFormats, start),
      afterFormats,
      end
    );

    return {formats: newFormats, text, start, end};
  },

  replaceWithLink(formats, partition, link) {
    if (link == null) {
      return this.replaceText(formats, partition, partition.selected);
    }
    const replacedText = this.replaceText(formats, partition, link.text);
    ({formats} = replacedText);
    const {text, start, end} = replacedText;
    formats =
      link.url != null
        ? this.addLink(formats, {start, end, url: link.url})
        : this.removeLink(formats, {start, end});
    return {formats, text, start, end};
  },

  replaceWithInternalLink(formats, partition, internalLink, index) {
    const position = partition.before.length;
    const replacedText = this.replaceText(formats, partition, ' ');
    ({formats} = replacedText);
    const {text, end} = replacedText;
    formats = this.addInternalLink(formats, {position, internalLink}, index);
    return {formats, text, end};
  },

  addLink(currentFormatRanges, {start, end, url}) {
    if (!isValidLink(url)) {
      return currentFormatRanges;
    }
    let links = currentFormatRanges[LINK];

    // Remove overlapping links
    const overlaps = getOverlappingLinks(currentFormatRanges[LINK], start, end);
    // eslint-disable-next-line no-restricted-syntax
    links = _.reject(links, (link) => Array.from(overlaps).includes(link));

    // Add new link
    links = links.concat([{start, end, data: {url}}]);
    const newFormats = reactUpdate(currentFormatRanges, {$merge: _.object([LINK], [links])});
    return newFormats;
  },

  addInternalLink(currentFormatRanges, {position, internalLink}, index) {
    const internalLinks = currentFormatRanges[INTERNAL_LINK].slice();
    internalLinks.splice(index, 0, {
      position,
      data: internalLink,
    });
    const newFormats = reactUpdate(currentFormatRanges, {$merge: _.object([INTERNAL_LINK], [internalLinks])});
    return newFormats;
  },

  removeLink(currentFormatRanges, {start, end}) {
    let links = currentFormatRanges[LINK];
    // eslint-disable-next-line no-restricted-syntax
    links = _.reject(links, (link) => link.start === start && link.end === end);
    const newFormats = reactUpdate(currentFormatRanges, {$merge: _.object([LINK], [links])});
    return newFormats;
  },

  // Returns the updated selection (if a link is partially selected), and the url
  // corresponding to the selected link. Also returns the before/selected/after text of the selection.
  getSelectionForAddLink(currentFormatRanges, {partition}) {
    let {before, selected, after} = partition;
    let start = before.length;
    let end = start + selected.length;
    const overlaps = getOverlappingLinks(currentFormatRanges[LINK], start, end);

    if (overlaps.length > 0) {
      start = Math.min(start, _(overlaps).chain().pluck('start').min().value());
      end = Math.max(end, _(overlaps).chain().pluck('end').max().value());
    }

    const fullText = before + selected + after;
    before = fullText.slice(0, start);
    after = fullText.slice(end);
    selected = fullText.slice(start, end);
    const url = overlaps.length > 0 ? overlaps[0].data.url : '';
    return {before, selected, after, url};
  },

  // Returns the HTML string for the given text/formats
  renderHTML(text, formats, param /* extends MediocreSearchResultProps */) {
    // TODO(T1075) Return a react component instead of HTML string.
    if (param == null) {
      param = {};
    }
    const {processText, paragraphMode, forceNonEmpty, listType, indentation} = param;
    formats = processRanges(formats); // TODO(T6442): this is to sanitize bad server data
    formats = addSearchResultsToFormats(formats, param);

    let html = '';
    let subtext;
    const linearFormats = linearizeFormats(formats);
    let curTextIndex = 0;
    for (const {format, index, type, data} of Array.from(linearFormats)) {
      subtext = _.escape(text.slice(curTextIndex, index));
      html += processText != null ? processText(subtext) : subtext;
      curTextIndex = index;
      if (type === EVENT.POINT) {
        html += renderFormatPoint(format, data, param);
      } else if (type === EVENT.START) {
        html += renderFormatStart(format, data);
      } else {
        assert(type === EVENT.END);
        html += renderFormatEnd(format);
      }
    }
    subtext = _.escape(text.slice(curTextIndex));
    if (paragraphMode) {
      html = `<P>${html.replace(/\n/g, '<P>')}`;
    }
    html += processText != null ? processText(subtext) : subtext;
    if (forceNonEmpty && html.length === 0) {
      return '&nbsp;';
    }
    // word does not respect our span and div styling we do for list items
    // instead, indent by providing ul tags
    if (listType === 'bullet' && indentation) {
      // TODO(BNCH-44988): add support for other listed items
      html = renderList(html, indentation);
    }
    return html;
  },

  isUnformatted(formats) {
    return Object.entries(formats).every(([, ranges]) => ranges.length === 0);
  },

  // Returns whether formats contain any values from POINT_FORMATS
  hasPointFormatting,

  // Returns whether formatted text is empty = has no raw text and no point elements
  isEmpty(fmtTexts) {
    if (fmtTexts.length > 1) {
      return false;
    }
    if (fmtTexts.length === 0) {
      return true;
    }
    const {text, formats} = fmtTexts[0];
    const hasPointFormats = hasPointFormatting(formats);
    return !(text.length || hasPointFormats);
  },

  // Returns the formats object starting from a given DOM node.
  // We currently only handle one level of super/subscript so any others will get flattened.
  getFormattedTextFromRenderedElement(el, offset, isInSubSuperscript, shouldProcessRanges, options) {
    if (offset == null) {
      offset = 0;
    }
    if (isInSubSuperscript == null) {
      isInSubSuperscript = false;
    }
    if (shouldProcessRanges == null) {
      shouldProcessRanges = true;
    }
    if (options == null) {
      options = {};
    }
    let text = '';
    let formats = this.defaultFormats();
    if (el.nodeType === Node.TEXT_NODE) {
      return {text: el.textContent, formats};
    }
    let shouldRecur = true;
    for (const {format, data} of Array.from(getFormatData(el, options))) {
      let shouldIncludeFormat = true;
      if ([SUPERSCRIPT, SUBSCRIPT].includes(format)) {
        shouldIncludeFormat = !isInSubSuperscript;
        isInSubSuperscript = true;
      }
      if (Array.from(POINT_FORMATS).includes(format)) {
        shouldRecur = false;
        shouldIncludeFormat = false;
        formats[format].push({position: offset, data});
      }
      if (shouldIncludeFormat) {
        // Only push a format if the text it formats is non-empty.
        const elText = $(el).text();
        if (elText.length !== 0) {
          formats[format].push({start: offset, end: offset + elText.length, data});
        }
      }
    }

    if (shouldRecur) {
      $(el)
        .contents()
        .each((i, child) => {
          const subFormattedText = this.getFormattedTextFromRenderedElement(
            child,
            offset,
            isInSubSuperscript,
            false, // `shouldProcessRanges` should be false on all recursive calls.
            options
          );
          const {text: subText, formats: subFormats} = subFormattedText;
          for (const format of Object.keys(subFormats)) {
            formats[format].push(...Array.from(subFormats[format] || []));
          }
          text += subText;
          offset += subText.length;
        });
    }

    // Only call `processRanges` on the outermost recursive call.
    if (shouldProcessRanges) {
      formats = processRanges(formats);
    }
    return {text, formats};
  },

  getSelectionIndicesFromFormatIndices(formats, prevStart, prevEnd) {
    let start = prevStart;
    let end = prevEnd;
    for (const format of Array.from(POINT_FORMATS)) {
      for (const point of Array.from(formats[format])) {
        if (point.position <= start) {
          start += CHIP_WIDTH;
        }
        if (point.position <= end) {
          end += CHIP_WIDTH;
        }
      }
    }

    return {start, end};
  },

  // Splits a formats object at the given index, and returns the two format objects.
  splitFormats(formats, index, afterPoint) {
    let before = this.defaultFormats();
    let after = this.defaultFormats();
    for (const format of Object.keys(formats)) {
      const ranges = formats[format];
      for (const range of Array.from(ranges)) {
        // Point formats have a position, not a start or end
        if (range.position != null) {
          if (range.position < index || (afterPoint && range.position === index)) {
            before[format].push(range);
          } else if (range.position > index || (!afterPoint && range.position === index)) {
            after[format].push({data: range.data, position: range.position - index});
          }
        } else {
          if (range.start < index) {
            before[format].push({start: range.start, end: Math.min(index, range.end), data: range.data});
          }
          if (range.end > index) {
            const start = Math.max(range.start, index) - index;
            const end = range.end - index;
            after[format].push({start, end, data: range.data});
          }
        }
      }
    }
    before = processRanges(before);
    after = processRanges(after);
    return {before, after};
  },

  // Joins two format objects into one, starting the second one at rightOffset.
  joinFormats(left, right, rightOffset) {
    const combined = this.defaultFormats();
    for (const format of Object.keys(left)) {
      const ranges = left[format];
      for (const range of Array.from(ranges)) {
        combined[format].push(range);
      }
    }
    for (const format of Object.keys(right)) {
      const ranges = right[format];
      for (const range of Array.from(ranges)) {
        // Point formats specify a position rather than a start and end
        if (range.position != null) {
          combined[format].push({data: range.data, position: range.position + rightOffset});
        } else {
          assert(range.start != null && range.end != null);
          combined[format].push({
            start: range.start + rightOffset,
            end: range.end + rightOffset,
            data: range.data,
          });
        }
      }
    }
    return processRanges(combined);
  },

  trimLeft(text, formats) {
    const isLeftLink = POINT_FORMATS.some((format) => formats[format].some((data) => data.position === 0));
    const trimmedText = isLeftLink ? text : text.trimLeft();
    formats = this.splitFormats(formats, text.length - trimmedText.length, false).after;
    return {text: trimmedText, formats};
  },

  trimRight(text, formats) {
    const isRightLink = POINT_FORMATS.some((format) =>
      formats[format].some((data) => data.position === text.length)
    );
    const trimmedText = isRightLink ? text : text.trimRight();
    formats = this.splitFormats(formats, trimmedText.length, true).before;
    return {text: trimmedText, formats};
  },

  trim(text, formats) {
    // When trimming whitespace with adjacent internal link chip = split index lies after the chip
    // Set afterPoint flag to false in trimLeft and true in trimRight
    const trimmedLeft = this.trimLeft(text, formats);
    const trimmed = this.trimRight(trimmedLeft.text, trimmedLeft.formats);
    return {text: trimmed.text, formats: trimmed.formats};
  },

  removeRange,

  /**
   * Test if all text within the given `selection` has the same formatting.
   *
   * @param {BenchlingSelection?} selection
   * @param {Format} formats - e.g. {"bold": [{start: 0, end: 1}}, ...}
   * @param {string, keyof Format} format - e.g. "bold"
   * @returns {boolean}
   */
  isSelectionFormatted(selection, formats, format) {
    if (!selection) {
      return false;
    }
    if (!formats[format]) {
      return false;
    }
    return formats[format].some((range) => range.start <= selection.start && range.end >= selection.end);
  },

  getFormatShortcut(format) {
    return FORMAT_TO_SHORTCUT[format];
  },
};

export default formatters;
